import React, { useState, useEffect } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
const DynamicBreadcrumbs = ({ menuData,handlePreviousList }) => {
    const { t } =useTranslation
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [currentRoute, setCurrentRoute] = useState('');
    const navigate=useNavigate();
    const menuValue=localStorage.getItem('sideMenu')

    useEffect(() => {
        let menu=JSON.parse(menuValue)
        const menuPatient =  menu?.find(item => item.pageName === "menu_patient" && menuData=='patient');
        const menuStructure = menu?.find(item => item.pageName === "menu_hospitals" && menuData==='structure');
        const menuPharmacy = menu?.find(item => item.pageName === "menu_hospitals" && menuData==='pharmacy');
        const menuRetail = menu?.find(item => item.pageName === "menu_hospitals" && menuData==='Retail');

        if (menuPatient) {
            setBreadcrumbs(
                <div className="d-flex align-items-center">
                    <h5
                        className="secondary-text-color fw-bold ms-4 clickable"
                        onClick={() => handlePreviousList()} 
                        style={{ cursor: 'pointer' }}
                    >
                        {"Assisitito"?.toUpperCase()}
                    </h5>
                    <h5 className="ms-2">{'>'}</h5>
                    <h4 className="secondary-text-color fw-bold ms-4">
                        {'Scheda Assistito'?.toUpperCase()}
                    </h4>
                </div>
            );
        }
        else if (menuStructure) {
            setBreadcrumbs(
                <div className="d-flex align-items-center">
                    <h5
                        className="secondary-text-color fw-bold ms-4 clickable"
                        onClick={handlePreviousList}
                        style={{ cursor: 'pointer' }}
                    >
                        {"STRUTTURE OSPEDALIERE".toUpperCase()}
                    </h5>
                    <h5 className="ms-2">{'>'}</h5>
                    <h4 className="secondary-text-color fw-bold ms-4">
                        {'SCHEDA STRUTTURA'.toUpperCase()}
                    </h4>
                </div>
            );
        }
        else if (menuPharmacy) {
            setBreadcrumbs(
                <div className="d-flex align-items-center">
                    <h5
                        className="secondary-text-color fw-bold ms-4 clickable"
                        onClick={handlePreviousList}
                        style={{ cursor: 'pointer' }}
                    >
                        {"FARMACIE OSPEDALIERE".toUpperCase()}
                    </h5>
                    <h5 className="ms-2">{'>'}</h5>
                    <h4 className="secondary-text-color fw-bold ms-4">
                        {'SCHEDA FARMACIA'.toUpperCase()}
                    </h4>
                </div>
            );
        }
        else if (menuRetail) {
            setBreadcrumbs(
                <div className="d-flex align-items-center">
                    <h5
                        className="secondary-text-color fw-bold ms-4 clickable"
                        onClick={handlePreviousList}
                        style={{ cursor: 'pointer' }}
                    >
                      {"FARMACIE RETAIL".toUpperCase()}
                    </h5>
                    <h5 className="ms-2">{'>'}</h5>
                    <h4 className="secondary-text-color fw-bold ms-4">
                    {'SCHEDA FARMACIA'.toUpperCase()}
                    </h4>
                </div>
            );
        }
    }, [menuData]);
    return (
        <div>
            {breadcrumbs}
        </div>
    );
};
export default DynamicBreadcrumbs

